<script>
    import { link } from "svelte-routing";

    const toEuro = new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    });

    export let orderFrameId;
  </script>
  
  
  <div class="singleMilkOption">
    <a href="/order/{orderFrameId}" use:link>
      <div class="milkOptionContent">
          <p>BESTELLUNG<br/>HINZUFÜGEN</p>
          <p>+</p>
      </div>
    </a>
  </div>
  
  
  <style>
    .singleMilkOption {
      user-select: none;
      border-radius: 10px;
      height: 120px;
      width: 210px;
      margin: 10px 10px;
      border: 2px dashed #BFBFBF;
      background: #F7F7F7;
      transform: scale(1) translateY(1px);
      transition: transform 0.15s ease-in-out,
        background 0.1s ease-in-out, border 0.1s ease-in-out,
        color 0.1s ease-in-out;
    }
    .singleMilkOption:hover {
      cursor: pointer;
      transform: scale(1.02);
    }

    .singleMilkOption a {
      text-decoration: none;
      color: #BFBFBF;
    }
  
    .singleMilkOption div.milkOptionContent {
      height: 100%;
      width: 100%;
      padding: 15px 0;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;
    }
    .singleMilkOption div.milkOptionContent > p {
      margin: 0;
    }
    .singleMilkOption div.milkOptionContent > p:nth-child(1) {
      font-size: 13px;
      font-weight: 500;
    }
    .singleMilkOption div.milkOptionContent > p:nth-child(2) {
      font-size: 40px;
    }
  </style>
  
  